import React from 'react'
import PropTypes from 'prop-types'
import { Text } from '@theneatcompany/nui'
import { FormattedMessage } from 'react-intl'

import useUserDeletedListener from '@/hooks/useUserDeletedListener'
import styles from '@/components/Layout/Layout.module.scss'
import Header from '@/components/Layout/Header'
import Footer from '@/components/Layout/Footer'
import Sidebar from '@/components/Layout/Sidebar'
import { useAccounts } from '@/components/Providers/AccountsProvider'
import LoadingScreen from '@/components/common/LoadingScreen'
import PartnerLayout from '@/components/Layout/PartnerLayout'
import AppStyles from '@/components/App.module.scss'
import { handleRedirectToAuth } from '@/hooks/useAuth'

export default function Layout({ children }) {
  const { isLoading, hasError, user } = useAccounts()

  useUserDeletedListener()

  if (isLoading) {
    return (
      <div className={AppStyles.app}>
        <LoadingScreen />
      </div>
    )
  }

  if (user?.type === 'partner') {
    return <PartnerLayout />
  }

  if (hasError) {
    handleRedirectToAuth()
  }

  return (
    <div id="app-layout" className={styles.layout}>
      <div id="app-sidebar" className={styles.sidebar}>
        <Sidebar />
      </div>

      <div id="app-primary" className={styles.primary}>
        <div id="app-header" className={styles.header}><Header /></div>

        <div id="app-main" className={styles.main}>{children}</div>

        <div id="app-footer" className={styles.footer}><Footer /></div>
      </div>
    </div>
  )
}

Layout.Content = ({ children }) => <div className={styles.content}>{children}</div>

Layout.Title = ({ messageId }) => (
  <Text element="h2" typeStyle="bold" type="display" className={styles.title}>
    <FormattedMessage id={messageId} />
  </Text>
)

Layout.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.element), PropTypes.element]).isRequired,
}

Layout.Content.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.element), PropTypes.element]).isRequired,
}

Layout.Title.propTypes = {
  messageId: PropTypes.string.isRequired,
}
